import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import service, { VERIFICATION_TOKEN } from 'kts-platform-frame/service';
import { connect, MyStore, reducers } from 'kts-platform-frame/redux';
import TotalModulesAction from '../Modules.Action';
import AppSdk from 'kts-platform-frame/appSdk';

class ModulesAction extends ActionBasic<ModulesState> {

    /** 更新 */
    updateAppList = async (): Promise<void> => {
        this.updateMenuList(true);
        const url = '/open-platform/app/instance/user-conf/query-my';
        const query = await service.post(url, {}).reqFs(VERIFICATION_TOKEN).end(this);
        if (query.err) {
            return;
        }
        this.modulesState.myAppList = query.res;
        await this.setModulesState();
    }
    /** 菜单 */
    updateMenuList = async (force?): Promise<void> => {
        const url = '/open-platform/app/instance/user-conf/query-popular-instance';
        const query = await service.post(url, {}).reqFs(VERIFICATION_TOKEN).end(this);
        if (query.err) {
            return;
        }
        this.modulesState.appMenu = query.res;
        await this.setModulesState(this.modulesState, ()=>{
            this.initCategoryMenu(force);
        });
    }

    initCategoryMenu = async (force?): Promise<void> => {
        const { appMenu , categoryMenu } = this.modulesState;
        let result = {};
        if(appMenu && !categoryMenu || force) {
                appMenu.map((item) => {
                    let appCategoryName = item.appCategoryName || '其他';
                    if (result[appCategoryName]) {
                        let itemList = result[appCategoryName];
                        itemList.push(item);
                        result[appCategoryName] = itemList;
                    } else {
                        result[appCategoryName] = [item];
                    }
                });
                let appKeys = Object.keys(result);
                let category = [];
                appKeys.map((key) => {
                    if (result[key] && result[key].length) {
                        category.push({appCategoryName:key, appCategoryIcon: result[key][0].categoryIcon, children: result[key]});
                    }
                });
                this.modulesState.categoryMenu = category;
                this.setModulesState();
        }
    }

    resetAppMenu = async (data?: Array<any>): Promise<void> => {
        const categoryMenu = data ? data : this.modulesState.categoryMenu;
        let appMenus = [];
        if(categoryMenu) {
            categoryMenu.map((item) => {
                const apps = item.children;
                if(apps && apps.length) {
                    appMenus = appMenus.concat(apps);
                }
            });
            await this.setMenu(appMenus);
        }
    }

    /** 获取模式 */
    queryMenuMode = async (): Promise<void> => {
        const url = '/company-biz/zone/userconfig/info/query';
        const query = await service.get(url, {}).reqFs(VERIFICATION_TOKEN).end(this);
        if (query.err) {
            return;
        }
        this.modulesState.menuMode = query.res.navigationMode;
        await this.setModulesState(this.modulesState, ()=>{
            this.initCategoryMenu();
        });
    }

    /** 设置模式 */
    toggleMode = async (): Promise<void> => {
        let { menuMode } = this.modulesState;
        if(menuMode === 1) {
            menuMode = 2;
            //设置分类模式，按照分类重新设置顺序
            this.resetAppMenu();
        }else {
            menuMode = 1;
        }
        const data = {
            navigationMode: menuMode
        };
        const url = '/company-biz/zone/userconfig/info/update';
        const query = await service.post(url, data).reqFs(VERIFICATION_TOKEN).end(this);
        if (query.err) {
            return;
        }
        this.modulesState.menuMode = menuMode;
        await this.setModulesState();
    }

    /**  设置配置菜单 */
    setMenu = async (menus: Array<any>): Promise<void> => {
        const { user } = MyStore.instance.getState();
        const params = {
            confList: menus,
            companyId: user.userInfo.companyId,
            userId: user.userInfo.cUserId,
            departmentId: user.userInfo.departmentId
        };
        const url = '/open-platform/app/instance/user-conf/batch-upsert';
        const query = await service.post(url, params).reqFs(VERIFICATION_TOKEN).end(this);
        if (query.err) {
            return;
        }
        this.modulesState.appMenu = menus;
        await this.setModulesState(this.modulesState, ()=>{
            this.initCategoryMenu(true);
        });
    }

    /**  取消常用 */
    cancelPopular = async (data: any): Promise<void> => {
        const instanceId = data.instanceId;
        const params = {
            instanceId,
            isPopular: 0
        };
        const url = '/open-platform/app/instance/user-conf/upsert';
        const query = await service.post(url, params).reqFs(VERIFICATION_TOKEN).end(this);
        if (query.err) {
            return;
        }
        //this.updateMenuList(true);
        AppSdk.instance.sendEvent('myAppChangeEvent', {});
    }

    /** 参看app列表里是否有制订的key */
    isHaveApp = (appKey: string) => this.modulesState.myAppList.some(value => {
        return value.appKey === appKey;
    })

    isShowApp = async () => {
        this.modulesState.isShow = true;
        const { user } = MyStore.instance.getState();
        const cuserInfo = JSON.parse(window.atob(user.cToken.split('.')[1])); 
        if(cuserInfo.userType === '1') {
            const query = await service.get('/global/account/authorize/admin').end(this); 
            this.modulesState.isShow = query.res; 
        }
        this.setModulesState();
    }

    setAppBoxVisible = (visibile: boolean)=>{
        this.modulesState.appBoxShow = visibile;
        this.setModulesState();
    }

}

export default new ModulesAction();


// WEBPACK FOOTER //
// ./src/display/modules/Home/Workbench2/Modules.Action.ts